const Product = {
  log: window.log,

  init() {
    this.quantitySelector();
    this.dogSizeSelector();
    this.subscriptionToggle();
    this.frequencySelector();
    this.updatePrice();
    this.addToCart();
    this.upsellATC();
    this.handleCartButton();
    this.handleReviewsSectionHeading();
  },

  productType: $("#variants-data").data("product-type").trim(),
  moneyFormat: $("#variants-data").data("money-format") || "£{{amount}}",
  hasVariants: $("#variants-data").data("has-variants") !== false,
  size: $(".pdp-main__product-option.size.active").data("size"),
  klarna: $(".pdp-main__klarna"),
  upsellId: $(".pdp-main__upsell").data("id"),
  selectedSellingPlanId: null,
  useSubscription: true,
  selectedQuantity:
    $(".pdp-main__quantity-option.active").data("quantity") || 1,

  get selectedVar() {
    const baseQuery = "#variants-data .variant-data";
    if (!this.hasVariants) {
      return $(baseQuery);
    }
    const query =
      baseQuery + `${this.size ? `[data-size=\"${this.size}\"]` : ""}`;
    const selected = $(query);
    window.product_selected_variant = selected.length ? selected : $(baseQuery);
    return selected.length ? selected : $(baseQuery);
  },

  // Format money using money format template
  formatMoney(priceInCents) {
    const price = (parseFloat(priceInCents) / 100).toFixed(2);
    return this.moneyFormat.replace(/\{\{[^}]*\}\}/g, price);
  },

  updatePrice() {
    const UPDATE_WITH_SUBS = false;
    const selectedVar = this.selectedVar;
    let basePrice = selectedVar.data("price") / 100;
    let comparePrice = selectedVar.data("compare-price") / 100 || basePrice;
    let finalPrice = basePrice;
    let saveAmount = 0;
    let savePercentage = 0;

    // Get subscription discount data once
    let subDiscount = 0;
    let subDiscountType = "percentage";
    // Champs flow: subscription discount comes from section setting, not Shopify selling plans
    const champsSubDiscount =
      parseFloat($("#subscription-toggle").data("champs-sub-discount")) || 0;
    if (this.useSubscription && champsSubDiscount > 0) {
      subDiscount = champsSubDiscount;
    } else if (this.useSubscription && this.selectedSellingPlanId) {
      const $selectedPlan = $(
        `.selling-plan-data input[value="${this.selectedSellingPlanId}"]`,
      );
      if ($selectedPlan.length) {
        subDiscountType = $selectedPlan.data("discount-type") || "percentage";
        subDiscount = parseFloat($selectedPlan.data("discount")) || 0;
      }
    }

    // Step 1: Apply subscription discount first
    if (subDiscount > 0) {
      if (subDiscountType === "percentage") {
        finalPrice = (finalPrice * (100 - subDiscount)) / 100;
        saveAmount = comparePrice - finalPrice;
        savePercentage = subDiscount;
        $(".pdp-main__frequency-discount-percentage").text(`${subDiscount}%`);
      } else if (subDiscountType === "price") {
        finalPrice = parseFloat((subDiscount / 100).toFixed(2));
        saveAmount = parseFloat((comparePrice - finalPrice).toFixed(2));
        savePercentage = parseFloat(
          ((saveAmount / comparePrice) * 100).toFixed(0),
        );
        $(".pdp-main__frequency-discount-percentage").text(
          `${savePercentage}%`,
        );
      } else {
        finalPrice = finalPrice - subDiscount;
        saveAmount = subDiscount;
        savePercentage = (subDiscount / comparePrice) * 100;
        $(".pdp-main__frequency-discount-percentage").text(
          `${savePercentage}%`,
        );
      }
    }

    // Step 3: Apply quantity discount to the subscription-adjusted price
    const $activeQty = $(".pdp-main__quantity-option.active");
    if ($activeQty.length) {
      this.selectedQuantity = parseInt($activeQty.data("quantity")) || 1;
      const qtyDiscount = parseFloat($activeQty.data("discount")) || 0;
      const qtyDiscountAmount =
        parseFloat($activeQty.data("saved-amount")) || 0;
      const qtyDiscountType = $activeQty.data("discount-type") || "percentage";

      if (qtyDiscount > 0 || qtyDiscountAmount > 0) {
        if (qtyDiscountType === "percentage") {
          finalPrice = (finalPrice * (100 - qtyDiscount)) / 100;
          saveAmount = comparePrice - finalPrice;
          savePercentage = qtyDiscount;
        } else {
          const discountInDollars = qtyDiscountAmount / 100;
          const totalPrice = finalPrice * this.selectedQuantity;
          finalPrice = (totalPrice - discountInDollars) / this.selectedQuantity;
          saveAmount = discountInDollars;
          savePercentage =
            (discountInDollars / (comparePrice * this.selectedQuantity)) * 100;
        }
      }
    }

    // Calculate final totals
    finalPrice = (finalPrice * this.selectedQuantity).toFixed(2);
    const totalComparePrice = (comparePrice * this.selectedQuantity).toFixed(2);

    // Calculate final save amount and percentage from totals
    saveAmount = (
      parseFloat(totalComparePrice) - parseFloat(finalPrice)
    ).toFixed(2);
    savePercentage = (
      (parseFloat(saveAmount) / parseFloat(totalComparePrice)) *
      100
    ).toFixed(2);

    // Update UI
    this.updateAddToCartButton(
      parseInt(selectedVar.data("stock")),
      !!selectedVar.data("available"),
    );
    this.updateMainPriceDisplay(
      totalComparePrice,
      finalPrice,
      saveAmount,
      savePercentage,
    );
    if (this.klarna.length) {
      const divide = Number(this.klarna.data("divide")) || 4;
      const klarnaPrice = `<strong>${this.formatMoney((parseFloat(finalPrice) / divide).toFixed(2) * 100)}</strong>`;
      this.klarna.find("p").html(
        (this.klarna.data("text") || "")
          .replace("[price]", klarnaPrice)
          .replace("[payments]", divide),
      );
      this.klarna.toggleClass("hidden", this.klarna.is("[data-otp-only]") && this.useSubscription);
    }

    // Update quantity option prices
    $(".pdp-main__quantity-option").each((index, element) => {
      const $option = $(element);
      if ($option.data("coc")) return;
      const quantity = parseInt($option.data("quantity")) || 1;
      const qtyDiscount = parseFloat($option.data("discount")) || 0;
      const qtyDiscountAmount = parseFloat($option.data("saved-amount")) || 0;
      const qtyDiscountType = $option.data("discount-type") || "percentage";

      let pricePerQuantity = basePrice;
      let savedAmountPerQuantity = 0;
      let saveAmountFromSubs = 0;

      // Apply subscription discount
      if (subDiscount > 0) {
        if (subDiscountType === "percentage") {
          pricePerQuantity = (pricePerQuantity * (100 - subDiscount)) / 100;
          saveAmountFromSubs = comparePrice - pricePerQuantity;
        } else if (subDiscountType === "price") {
          pricePerQuantity = parseFloat((subDiscount / 100).toFixed(2));
          saveAmountFromSubs = comparePrice - pricePerQuantity;
        } else {
          pricePerQuantity = pricePerQuantity - subDiscount;
          saveAmountFromSubs = subDiscount;
        }
      }

      // Apply quantity discount
      if (qtyDiscount > 0 || qtyDiscountAmount > 0) {
        if (qtyDiscountType === "percentage") {
          savedAmountPerQuantity = (pricePerQuantity * qtyDiscount) / 100;
          pricePerQuantity -= savedAmountPerQuantity;
        } else {
          const discountInDollars = qtyDiscountAmount / 100;
          const totalPrice = pricePerQuantity * quantity;
          pricePerQuantity = (totalPrice - discountInDollars) / quantity;
          savedAmountPerQuantity = discountInDollars / quantity;
        }
      }

      const pricePerServing = (
        pricePerQuantity / +$option.data("servings")
      ).toFixed(2);

      // Update displays
      const $priceElement = $option.find(".pdp-main__quantity-price");
      const $saveElement = $option.find(".pdp-main__quantity-save");
      const $servingsElement = $option.find(".pdp-main__quantity-servings");

      if ($priceElement.length)
        $priceElement.html(
          `${this.formatMoney(pricePerQuantity.toFixed(2) * 100)} <span class="pdp-main__quantity-each">/ Each</span>`,
        );
      if ($saveElement.length) {
        const totalSavedAmount =
          (savedAmountPerQuantity +
            (UPDATE_WITH_SUBS ? saveAmountFromSubs : 0)) *
          quantity;
        $saveElement
          .toggle(totalSavedAmount > 0)
          .text(
            totalSavedAmount > 0
              ? `Save ${this.formatMoney(totalSavedAmount.toFixed(2) * 100)}`
              : "",
          );
      }
      if ($servingsElement.length)
        $servingsElement.text(
          `${this.formatMoney(pricePerServing * 100)} per serving`,
        );
    });
  },

  updateMainPriceDisplay(
    originalPrice,
    discountedPrice,
    saveAmount,
    savePercentage,
  ) {
    const priceClass = ".pdp-main__prices:not(.pdp-main__upsell-prices)";
    const hasDiscount = parseFloat(saveAmount) > 0;

    // Update main prices (only if they exist)
    if ($(`${priceClass} s`).length) {
      $(`${priceClass} s`)
        .toggleClass("hidden", !hasDiscount)
        .text(this.formatMoney(originalPrice * 100));
    }
    if ($(`${priceClass} h3`).length) {
      $(`${priceClass} h3`).text(this.formatMoney(discountedPrice * 100));
    }
    if ($(`${priceClass} p`).length) {
      $(`${priceClass} p`)
        .toggleClass("hidden", !hasDiscount)
        .text(`Save ${this.formatMoney(saveAmount * 100)}`);
    }

    // Update subscription save percentage (only if it exists)
    if ($(".pdp-main__frequency-save-price").length) {
      $(`.pdp-main__frequency-save-price`)
        .toggleClass("hidden", parseFloat(savePercentage) <= 0)
        .text(`Save ${savePercentage}%`);
    }

    // Update ATC total price (only if it exists) - multiply by quantity
    if ($(".pdp-main__atc-total-price").length) {
      $(".pdp-main__atc-total-price").text(
        this.formatMoney(discountedPrice * 100),
      );
    }
    if ($(".pdp-main__atc-compare-price").length) {
      $(".pdp-main__atc-compare-price").text(
        this.formatMoney(originalPrice * 100),
      );
    }
    if ($(".pdp-main__otp-atc").length) {
      const otpATCText = $(".pdp-main__otp-atc").data("text");
      $(".pdp-main__otp-atc").text(
        otpATCText.replace(
          "[otp_price]",
          this.formatMoney(originalPrice * 100),
        ),
      );
    }
  },

  updateAddToCartButton(stock, available) {
    if (stock <= 0 && !available) {
      $(".pdp-main__atc-btn")
        .addClass("soldout")
        .find(".pdp-main__atc-text")
        .text("Sold Out");
    } else {
      const atcMainText = $(".pdp-main__atc-btn")
        .find(".pdp-main__atc-text")
        .data("main-text");
      $(".pdp-main__atc-btn")
        .removeClass("soldout")
        .find(".pdp-main__atc-text")
        .text(atcMainText);
    }
  },

  dogSizeSelector() {
    $(document).on("click", ".pdp-main__dog-size", (e) => {
      const targetQuantity =
        parseInt($(e.currentTarget).data("quantity")) || null;
      if (!targetQuantity) return;

      const $targetOption = $(
        `.pdp-main__quantity-option[data-quantity="${targetQuantity}"]`,
      );
      if ($targetOption.length) {
        $(".pdp-main__dog-size").removeClass("active");
        $(e.currentTarget).addClass("active");
        $('.pdp-main__product-variants-label span[data-type="dog_size"]').text(
          $(e.currentTarget).find("p").text(),
        );
        $targetOption.trigger("click");
      }
    });
  },

  quantitySelector() {
    $(document).on(
      "click",
      ".pdp-main__quantity-option, .pdp-main__quantity-options.compact-gifts .pdp-main__quantity-gifts-wrapper",
      (e) => {
        let $option;
        if ($(e.currentTarget).hasClass("pdp-main__quantity-gifts-wrapper")) {
          // If clicking the gifts wrapper, select the previous sibling .pdp-main__quantity-option
          $option = $(e.currentTarget).prev(".pdp-main__quantity-option");
        } else {
          $option = $(e.currentTarget);
        }
        if (!$option.length) return;

        $(".pdp-main__quantity-option").removeClass("active");
        $option.addClass("active");
        const {
          featuredGiftQuantity: featured_gift_quantity,
          featuredGiftImage: featured_gift_image,
        } = $option.data();
        const quantityLabel = $option.find(".pdp-main__quantity-name").text();
        if (quantityLabel)
          $(
            '.pdp-main__product-variants-label span[data-type="quantity"]',
          ).text(`${quantityLabel}`);
        this.selectedQuantity = parseInt($option.data("quantity")) || 1;

        this.updateFrequencyBasedOnQuantity(this.selectedQuantity);
        this.updateFeaturedGift(featured_gift_quantity, featured_gift_image);
        this.updatePrice();
      },
    );
    // Set preselected as active by default
    const $quantityOptions = $(".pdp-main__quantity-option");
    let preselectedInd =
      +$(".pdp-main__quantity-options").data("preselected") || 1;
    preselectedInd =
      preselectedInd > 0 && preselectedInd <= $quantityOptions.length
        ? preselectedInd
        : 1;
    const $shouldBeActiveOption = $quantityOptions.eq(preselectedInd - 1);
    if ($shouldBeActiveOption.length) {
      $shouldBeActiveOption.addClass("active");
      this.selectedQuantity =
        parseInt($shouldBeActiveOption.data("quantity")) || 1;

      this.updateFrequencyBasedOnQuantity(this.selectedQuantity);
      const {
        featuredGiftQuantity: featured_gift_quantity,
        featuredGiftImage: featured_gift_image,
      } = $shouldBeActiveOption.data();
      this.updateFeaturedGift(featured_gift_quantity, featured_gift_image);
    }
  },

  subscriptionToggle() {
    // Listener for subscription toggle checkbox
    $(document).on("change", "#subscription-toggle", (e) => {
      this.useSubscription = $(e.currentTarget).is(":checked");

      $(".pdp_dynamic-content-sub").toggleClass("hided", !this.useSubscription);
      $(".pdp_dynamic-content-otp").toggleClass("hided", this.useSubscription);
      $(".pdp-main__subscription-content")[
        this.useSubscription ? "slideDown" : "slideUp"
      ](300);

      $(".pdp-main__sub-compact-gift").toggleClass(
        "active",
        this.useSubscription,
      );
      $(
        ".pdp-main__frequency-option-label, .pdp-main__frequency-change-toggle",
      ).toggleClass("hidden", !this.useSubscription);

      this.updatePrice();
    });

    // Add click listener for .pdp-main__sub-compact-gift to toggle subscription
    $(document).on("click", ".pdp-main__sub-compact-gift", function (e) {
      const $toggle = $("#subscription-toggle");
      if ($toggle.is(":checked")) return;
      $toggle.prop("checked", !$toggle.is(":checked")).trigger("change");
      $(this).toggleClass("active", $toggle.is(":checked"));
    });

    // Set initial value
    this.useSubscription = $("#subscription-toggle").is(":checked");
  },

  updateFrequencyStatus() {
    // Disable frequency selector if quantity is greater than 1
    // due to BUYQuantityOFFER discount codes not working with subs properly
    const isFrequencyDisabled = this.selectedQuantity > 1;
    $(".pdp-main__frequency.sub").toggleClass("disabled", isFrequencyDisabled);
    $("#subscription-toggle").prop("checked", !isFrequencyDisabled);
    this.useSubscription = !isFrequencyDisabled;
    this.useSubscription
      ? $(".pdp-main__subscription-content").slideDown(300)
      : $(".pdp-main__subscription-content").slideUp(300);
  },

  frequencySelector() {
    // Compact: toggle frequency selector
    $(document).on("click", ".pdp-main__frequency-change-toggle", function (e) {
      e.preventDefault();
      // Hide the toggle button itself and the subscription content
      $(this).add(".pdp-main__subscription-content").toggleClass("hidden");
    });
    // Frequency selector
    $(document).on("change", ".pdp-main__frequency-select", (e) => {
      this.selectedSellingPlanId = $(e.currentTarget).val();
      $(".pdp-main__frequency-option-label span").text(
        $(e.currentTarget).find("option:selected").text(),
      );
      this.updatePrice();
    });
    const $initSelect = $(".pdp-main__frequency-select");
    if ($initSelect.length) {
      this.selectedSellingPlanId = $initSelect.val();
      $(".pdp-main__frequency-option-label span").text(
        $initSelect.find("option:selected").text(),
      );
    }
  },

  updateFrequencyBasedOnQuantity(quantity) {
    const $frequencySelect = $(".pdp-main__frequency-select");
    if (!$frequencySelect.length) return;

    const defaultPlanId = $("#variants-data").data("default-selling-plan-id");
    // 1. If default-selling-plan-id exists and is in the select, use it
    if (
      defaultPlanId &&
      $frequencySelect.find(`option[value="${defaultPlanId}"]`).length
    ) {
      $frequencySelect.val(defaultPlanId);
      this.selectedSellingPlanId = defaultPlanId;
      return;
    }

    // 2. Try to map quantity to days and find a matching option
    const quantityToDays = { 1: 30, 2: 60, 3: 90 };
    const targetDays = quantityToDays[quantity];
    let foundOption = null;

    if (targetDays) {
      $frequencySelect.find("option").each((index, option) => {
        const optionText = $(option).text().toLowerCase();
        if (
          optionText.includes(targetDays.toString()) ||
          optionText.includes(`${targetDays} day`)
        ) {
          foundOption = option;
          return false; // break
        }
      });
    }

    if (foundOption) {
      $frequencySelect.val($(foundOption).val());
      this.selectedSellingPlanId = $(foundOption).val();
      $(".pdp-main__frequency-option-label span").text($(foundOption).text());
    } else {
      // 3. Fallback: use first available selling plan
      $frequencySelect.prop("selectedIndex", 0);
      this.selectedSellingPlanId = $frequencySelect.val();
      $(".pdp-main__frequency-option-label span").text(
        $frequencySelect.find("option:selected").text(),
      );
    }
  },

  updateFeaturedGift(featured_gift_quantity, featured_gift_image) {
    const $featuredGift = $(".pdp-main__subscription-gift");
    if (
      !$featuredGift.length ||
      !featured_gift_quantity ||
      !featured_gift_image
    )
      return;
    const { price, text } = $featuredGift.data();
    const featuredGiftText = text.replace(
      "[gift_quantity]",
      featured_gift_quantity,
    );
    const featuredGiftPrice = (
      (+price * +featured_gift_quantity) /
      100
    ).toFixed(2);

    $featuredGift
      .find(".pdp-main__subscription-gift-text")
      .html(featuredGiftText);
    $featuredGift
      .find(".pdp-main__subscription-gift-image img")
      .attr("srcset", `${featured_gift_image} 100w`);
    $featuredGift
      .find(".pdp-main__subscription-gift-tag s")
      .html(this.formatMoney(featuredGiftPrice * 100));
  },

  klaviyoATC(item = null) {
    // Always fetch cart from /cart.js and fire Klaviyo event
    const _learnq = window._learnq || [];
    fetch(`${window.location.origin}/cart.js`)
      .then((res) => (res.ok ? res.json() : null))
      .then((cartData) => {
        if (!cartData || typeof cartData !== "object") return;
        let payload = {
          total_price: cartData.total_price / 100,
          $value: cartData.total_price / 100,
          total_discount: cartData.total_discount,
          original_total_price: cartData.original_total_price / 100,
          items: cartData.items,
        };
        if (item && typeof item === "object") {
          payload = Object.assign(payload, item);
        }
        _learnq.push(["track", "Added to Cart", payload]);
      });
  },

  addToCartWithoutClear(items, callback, onFinally) {
    $.post("/cart/add.js", { items })
      .done(() => {
        this.klaviyoATC();
        callback();
      })
      .fail((e) =>
        this.log.collapse({ e }, "Error adding items to cart.", "error"),
      )
      .always(() => onFinally?.());
  },
  addToCartWithClear(items, callback) {
    $.post("/cart/clear.js")
      .done(() => {
        $.post("/cart/add.js", { items })
          .done(() => {
            this.klaviyoATC();
            callback();
          })
          .fail((e) =>
            this.log.collapse({ e }, "Error adding items to cart.", "error"),
          );
      })
      .fail((e) => this.log.collapse({ e }, "Error clearing cart.", "error"));
  },

  addToCart() {
    $(".pdp-main__atc-btn, .pdp-sticky__button, .pdp-main__otp-atc").click(
      (e) => {
        e.preventDefault();
        const selectedVar = this.selectedVar;
        const id = selectedVar.data("id");
        let selling_plan = undefined;

        const skipCart =
          $(".pdp-main__atc-btn").attr("data-skip-cart") == "true";
        const atcFlow = $(".pdp-main__atc-btn").attr("data-flow") || "cart";

        if (window._learnq && typeof window._learnq.push === "function") {
          _learnq.push(["track", "Added to Cart", item]);
          console.log("Added to cart to klaviyo sent");
        }

        // Check if subscription toggle is enabled
        if (
          this.useSubscription &&
          this.selectedSellingPlanId &&
          !$(e.currentTarget).hasClass("pdp-main__otp-atc")
        ) {
          selling_plan = this.selectedSellingPlanId;
        }

        const quantity = this.selectedQuantity || 1;
        this.log.collapse(
          { selectedVar, id, selling_plan, quantity },
          "Adding to Cart",
          "warning",
        );
        if (!id) return alert("Please select a product option.");

        const items = [{ id, quantity, selling_plan }];

        if (
          skipCart == true &&
          !$(e.currentTarget).hasClass("pdp-main__otp-atc")
        ) {
          // Skip Cart Flow, Checkout Page, Add hardcoded gifts
          const giftId = $(".gift_input-value").attr("data-id");
          if (giftId) {
            items.push({ id: giftId, quantity: quantity });
          }
          if (quantity == 3) {
            const gift100Id = $(".gift_input-value_100").attr("data-id");
            items.push({ id: gift100Id, quantity: 1 });
          }

          if ($(e.currentTarget).hasClass("popup-upsell__trigger")) {
            this.handlePopupUpsell(selectedVar, items);
          } else {
            log.collapse({ items }, "Adding to Cart", "warning");

            this.addToCartWithClear(items, () => {
              window.location.href = "/checkout";
            });
          }

        } else if (atcFlow == "checkout") {
          if ($(e.currentTarget).hasClass("popup-upsell__trigger")) {
            this.handlePopupUpsell(selectedVar, items);
          } else {
            log.collapse({ items }, "Adding to Cart", "warning");
            this.addToCartWithClear(items, () => {
              window.location.href = "/checkout";
            });
          }
        } else if (atcFlow == "champs") {
          const baseChampsUrl = $("#variants-data").data("champs-url") || $("#champs-url").val();
          if (!baseChampsUrl) {
            return alert("Champs checkout URL not configured.");
          }
          // Champs handles subscriptions itself, so don't depend on Shopify selling plans
          const isSubscription =
            this.useSubscription &&
            !$(e.currentTarget).hasClass("pdp-main__otp-atc");
          const $activeQty = $(".pdp-main__quantity-option.active");
          const champsSubId =
            $activeQty.attr("data-sub-champs-id") ||
            selectedVar.attr("data-sub-champs-id");
          const champsOtpId =
            $activeQty.attr("data-otp-champs-id") ||
            selectedVar.attr("data-otp-champs-id");
          const champsProductId =
            isSubscription ? champsSubId || champsOtpId : champsOtpId;

          if (!champsProductId) {
            return alert("Champs product ID not configured.");
          }

          const champsId =
            champsProductId + "%3A" + (this.selectedQuantity || 1);
          let champsUrl = baseChampsUrl + "?products=" + champsId;

          const activeGifts = $(".pdp-main__quantity-option.active + .pdp-main__quantity-gifts-wrapper .pdp-main__quantity-gift");
          activeGifts.each((index, gift) => {
            const champsId = $(gift).data("champs-id");
            const quantity = $(gift).data("quantity");
            const isSub = $(gift).hasClass("sub-only");
            if (champsId && (isSub && isSubscription || !isSub)) {
              champsUrl += ";" + champsId + "%3A" + (quantity || 1);
            }
            log.collapse({ giftId: champsId, giftQuantity: quantity, giftIsSub: isSub }, "Champs ATC Gift", "info");
          });

          log.collapse({ champsUrl, isSubscription, champsSubId, champsOtpId, champsId }, "Champs ATC Flow", "warning");
          window.location.href = champsUrl;
        } else {
          // Regular Flow, Cart Drawer
          if ($(e.currentTarget).hasClass("popup-upsell__trigger")) {
            this.handlePopupUpsell(selectedVar);
          } else {
            const $btn = $(e.currentTarget);
            $btn.addClass("loading");
            this.addToCartWithoutClear(
              items,
              () => {
                window.UPDATE_CART?.();
                window.OPEN_CART?.();
                this.klaviyoATC();
              },
              () => $btn.removeClass("loading"),
            );
          }
        }
      },
    );
  },

  upsellATC() {
    const upsellAtcButton = $(".pdp-main__upsell-atc");
    upsellAtcButton.on("click", (e) => {
      e.preventDefault();
      upsellAtcButton.disabled = true;
      const upsellId = this.upsellId || upsellAtcButton.data("id");
      this.log.collapse({ upsellId }, "UPSELL: Adding to Cart", "warning");

      this.addToCartWithoutClear([{ id: upsellId, quantity: 1 }], () => {
        window.UPDATE_CART?.();
        window.OPEN_CART?.();
        this.klaviyoATC();
      }).always(() => (upsellAtcButton.disabled = false));
    });
  },

  handleCartButton() {
    $(".product_form .cart_button").on("click", (e) => {
      e.preventDefault();
      const selectedVar = this.selectedVar;
      const quantity = $('form.pro_quantity input[name="quantity"]').val();
      const id = selectedVar.data("id");

      $.post("/cart/add.js", { items: [{ id, quantity }] })
        .done((cart) => {
          window.UPDATE_CART?.();
          window.OPEN_CART?.();
          this.klaviyoATC();
        })
        .fail((e) =>
          this.log.collapse({ e }, "Error adding item to cart.", "error"),
        );
    });
  },

  handlePopupUpsell(selectedVar) {
    const popup = $(".popup-upsell");
    const upsellAtcButton = popup.find(".popup-upsell__atc-btn");
    const originalId = selectedVar.data("id");
    const totalPrice =
      (Number(selectedVar.data("price")) +
        Number(upsellAtcButton.data("price"))) /
      100;

    popup
      .find(".popup-upsell__atc-price")
      .text(this.formatMoney(totalPrice * 100));
    popup.addClass("active");

    // Start the timer if it exists
    if (window.popupUpsellTimer) window.popupUpsellTimer.start();

    const closePopupAndAddToCart = (items) => {
      // Stop timer if it exists
      if (window.popupUpsellTimer) {
        window.popupUpsellTimer.stop();
      }
      popup.removeClass("active");

      this.addToCartWithoutClear(items, () => {
        window.UPDATE_CART?.();
        window.OPEN_CART?.();
        this.klaviyoATC();
      });
    };

    // Remove any existing click handlers
    upsellAtcButton.off("click");
    popup.find(".popup-upsell__decline").off("click");

    // Add new click handlers
    upsellAtcButton.on("click", () => {
      closePopupAndAddToCart([
        { id: originalId, quantity: 1 },
        { id: upsellAtcButton.data("id"), quantity: 1 },
      ]);
    });

    popup.find(".popup-upsell__decline").on("click", () => {
      closePopupAndAddToCart([{ id: originalId, quantity: 1 }]);
    });
  },

  handleReviewsSectionHeading() {
    const badge = $(".judgeme-count-wrapper .jdgm-prev-badge").clone();
    const textPrepend = "<span>Rated 4.9 / 5 by </span>";
    const textAppend = "<span> Pet Parents</span>";
    badge
      .css({
        display: "flex",
        "flex-wrap": "wrap",
      })
      .find(".jdgm-prev-badge__stars")
      .css({
        display: "flex",
        gap: "2px",
      });
    const tpRatingsCount = $(".judgeme-count-container").html();
    const badgeText = badge.find(".jdgm-prev-badge__text");
    if (tpRatingsCount && tpRatingsCount.trim() !== "")
      badgeText.html(tpRatingsCount);
    badgeText.before(textPrepend).after(textAppend).css("padding-left", "0");

    const countContainer = $(".testimonial_heading .subheading");
    if (countContainer.length && badge.length)
      countContainer.empty().append(badge);
  },
};

$(document).ready(function () {
  Product.init();

  // Reviews scroller dots
  function initReviewsDots() {
    const $scroller = $(".pdp-main_stat_reviews_scroller");
    const $dots = $(".pdp-main__static_dot");
    const $cells = $(".pdp-main_stat_review_cell");

    if (!$scroller.length || !$dots.length || !$cells.length) return;

    $dots.on("click", function () {
      const index = $(this).data("index") - 1;
      const cell = $cells[index];
      if (cell) {
        $scroller[0].scrollTo({ left: cell.offsetLeft, behavior: "smooth" });
      }
    });

    $scroller.on("scroll", function () {
      const scrollLeft = this.scrollLeft;
      let closest = 0;
      let minDist = Infinity;
      $cells.each(function (i) {
        const dist = Math.abs(this.offsetLeft - scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      $dots.removeClass("active").eq(closest).addClass("active");
    });
  }

  initReviewsDots();
});
